// Polling que respeita a aba ESCONDIDA (regra e relógio em pollingVisivelCore.js).
import { useEffect, useRef } from 'react';
import { abaVisivel, iniciarPollingVisivel } from './pollingVisivelCore';

export { abaVisivel, iniciarPollingVisivel };

/** Hook: `usePollingVisivel(carregar, 60000)`. Usa sempre a versão mais nova de `fn`. */
export function usePollingVisivel(fn, ms, { imediato = true, ativo = true } = {}) {
  const ref = useRef(fn);
  ref.current = fn;
  useEffect(() => {
    if (!ativo) return undefined;
    return iniciarPollingVisivel(() => ref.current && ref.current(), ms, { imediato });
  }, [ms, imediato, ativo]);
}
